export const playerLogin = {
  action: "ACTION",
  ip: "IP",
  success: "SUCCESS",
  date: "DATE",
};
